module.exports = __webpack_public_path__ + "img/bookmarkicon.b2a3830b.svg";